import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fire-and-forget page-view tracker. Logs one visit per route change.
 * - Throttled to once per 800ms to defuse React StrictMode double-mount in dev
 * - Admin pages excluded (we don't track ourselves)
 * - Failures are swallowed — analytics must never break the UX
 */
let lastSent = { path: null, t: 0 };

export default function useTrackVisits() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + (location.search || "");
    const now = Date.now();
    if (path.startsWith("/admin")) return;
    if (lastSent.path === path && now - lastSent.t < 800) return;
    lastSent = { path, t: now };
    api.logVisit({
      path,
      referrer: document.referrer || null,
      ua: navigator.userAgent || null,
    }).catch(() => {});
  }, [location.pathname, location.search]);
}
